import React from "react";

import cx from "classnames";

export type CardBodyProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const CardBody: React.FC<React.PropsWithChildren<Readonly<CardBodyProps>>> = ({
  className,
  children,
  ...props
}) => (
  <div {...props} className={cx("px-4 py-2 sm:px-6", className)}>
    {children}
  </div>
);
